import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, MessageCircle, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10 py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-r from-[#C5A059] to-[#E5C578] rounded-sm flex items-center justify-center font-bold text-black text-xl">
                DG
              </div>
              <span className="font-manrope font-bold text-xl text-white">
                DigitalGoldGang
              </span>
            </div>
            <p className="text-gray-400 text-sm mb-4 max-w-sm">
              A Web3-native financial intelligence platform built for the new generation of investors.
              Educate. Analyze. Prepare. Execute.
            </p>
            <div className="flex items-center space-x-4">
              <a href="#" className="text-gray-400 hover:text-[#C5A059] transition-colors" aria-label="Twitter">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#C5A059] transition-colors" aria-label="Telegram">
                <MessageCircle size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#C5A059] transition-colors" aria-label="YouTube">
                <Youtube size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-manrope font-semibold text-white mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/education" className="text-gray-400 text-sm hover:text-[#C5A059] transition-colors">
                  Education Hub
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-gray-400 text-sm hover:text-[#C5A059] transition-colors">
                  Market News
                </Link>
              </li>
              <li>
                <Link to="/forum" className="text-gray-400 text-sm hover:text-[#C5A059] transition-colors">
                  Community Forum
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 text-sm hover:text-[#C5A059] transition-colors">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-manrope font-semibold text-white mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/macro-brief" className="text-gray-400 text-sm hover:text-[#C5A059] transition-colors">
                  Weekly Macro Brief
                </Link>
              </li>
              <li>
                <Link to="/live-chart" className="text-gray-400 text-sm hover:text-[#C5A059] transition-colors">
                  Live Markets
                </Link>
              </li>
              <li>
                <Link to="/disclaimer" className="text-gray-400 text-sm hover:text-[#C5A059] transition-colors">
                  Disclaimer
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 text-sm hover:text-[#C5A059] transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 text-sm hover:text-[#C5A059] transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Disclaimer Banner */}
        <div className="mt-8 p-4 bg-[#111111] border border-white/10 rounded-lg">
          <p className="text-gray-400 text-xs text-center">
            <span className="text-[#C5A059] font-semibold">Disclaimer:</span> Educational content only. Not financial advice. Trading involves substantial risk of loss. 
            <Link to="/disclaimer" className="text-[#C5A059] hover:underline ml-1">Read full disclaimer</Link>
          </p>
        </div>

        <div className="mt-8 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            © 2026 DigitalGoldGang. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm mt-2 md:mt-0">
            Powered by <span className="text-[#C5A059]">Emergent Labs</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
